import { useFormik } from 'formik'
import React, { useContext, useState } from 'react'
import AppToaster from '../../commonLib/AppToaster'
import *as Yup from "yup"
import * as productionCategoryCrud from '../../_crud/productionCategoryCrud'
import { useHistory } from 'react-router-dom'
import { GetEProductionCategoryType } from '../../enumCollections/EProductionCategoryType'
import { Container } from '../../base/Container'
import { LoadingButton } from '../../commonLib/LoadingButton'
import { loadingMiniContext } from '../../commonLib/lodingMiniContext'
import { TextBoxTranslater } from '../../commonLib/TextBoxTranslater'

const initialValues = {
    productionCatName: "",
    type: 2
}

export function AddCategory() {
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const history = useHistory()

    const Schema = Yup.object().shape({
        productionCatName: Yup.string().min(3, "Category Name must between 3 to 15 characters").max(15, "Category Name must between 3 to 15 characters").required("Category Name is required."),
        type: Yup.string().required("Type is required."),
    })

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values) => {
            Save(values);
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });
    const Save = (value) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        productionCategoryCrud.Add(value)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster('Added successfully.', 'success')
                    history.goBack()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    return (
        <>
            <Container title="Add Category" isBack="true">
                <form onSubmit={formik.handleSubmit} class="form-horizontal">
                    <div className="row">
                        <div className="col-md-6">
                            <div class="form-group">
                                <div class="col-xs-12">
                                <label class="control-label no-padding-right">Category</label>
                                    <TextBoxTranslater className="form-control" type="text" placeholder="Category Name" name="productionCatName" value={formik.values.productionCatName} onChange={(e) => formik.setValues({ ...formik.values, productionCatName: e.target.value })} />
                                    {
                                        formik.touched.productionCatName &&
                                            formik.errors.productionCatName ? (
                                            <label className="text-danger" >
                                                {formik.errors.productionCatName}
                                            </label>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div class="form-group">
                                <div class="col-xs-12">
                                <label class="control-label no-padding-right">Type</label>
                                    <select className="form-control" name="type" value={formik.values.type} onChange={(e) => formik.setValues({ ...formik.values, type: e.target.value })}>
                                        <option value="" >Select...</option>

                                        {
                                            GetEProductionCategoryType.EProductionCategoryType.map((data, index) =>
                                                <option key={data.Id} value={data.Id}>{data.Name}</option>
                                            )
                                        }
                                    </select>
                                    {
                                        formik.touched.type &&
                                            formik.errors.type ? (
                                            <label className="text-danger" >
                                                {formik.errors.type}
                                            </label>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix form-actions">
                        <div class="pull-right">
                            {isLoadingLocal ?
                                <LoadingButton />
                                :
                                <button class="btn btn-info" type="submit" expand="block" disabled={!formik.isValid}>
                                    <i class="ace-icon fa fa-check bigger-110"></i>
                                    Add
                                </button>}
                        </div>
                    </div>
                </form>
            </Container >
        </>
    )
}
